import { render, staticRenderFns } from "./SubTopNavbar.vue?vue&type=template&id=8ab79150&scoped=true&"
import script from "./SubTopNavbar.vue?vue&type=script&lang=js&"
export * from "./SubTopNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab79150",
  null
  
)

export default component.exports